/** Wie viele Minuten eine Zeitzone zu einem Zeitpunkt vor UTC liegt. */
function offsetMinutes(instant: Date, timeZone: string): number {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat("en-US", {
      timeZone,
      hourCycle: "h23",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    })
      .formatToParts(instant)
      .map((part) => [part.type, part.value]),
  );
  const asUtc = Date.UTC(
    Number(parts.year),
    Number(parts.month) - 1,
    Number(parts.day),
    Number(parts.hour),
    Number(parts.minute),
    Number(parts.second),
  );
  return Math.round((asUtc - instant.getTime()) / 60_000);
}

/**
 * Ein Zeitpunkt als Wert für `<input type="datetime-local">` in der Zeitzone des
 * Halts — nicht in der des Geräts. Wer in Berlin eine Fähre ab Helsinki pflegt, trägt
 * die Abfahrt in Helsinkier Zeit ein.
 */
export function toZonedInput(iso: string | null, timeZone: string): string {
  if (!iso) {
    return "";
  }
  const instant = new Date(iso);
  const local = new Date(instant.getTime() + offsetMinutes(instant, timeZone) * 60_000);
  return local.toISOString().slice(0, 16);
}

/** Der Wert eines `datetime-local`-Felds, gelesen in der Zeitzone des Halts, als ISO-Zeitpunkt. */
export function fromZonedInput(value: string, timeZone: string): string | null {
  if (!value) {
    return null;
  }
  const naive = new Date(`${value}:00Z`);
  // Zweimal schätzen: der Versatz am gesuchten Zeitpunkt kann um eine Zeitumstellung
  // von dem am Schätzwert abweichen.
  let guess = naive.getTime() - offsetMinutes(naive, timeZone) * 60_000;
  guess = naive.getTime() - offsetMinutes(new Date(guess), timeZone) * 60_000;
  return new Date(guess).toISOString();
}
